module.exports = __webpack_public_path__ + "media/new-pdf-report-layout/badanie-techniczne@3x-7eade935.svg";